<template>
	<div class="goods">
		<v-head :title="title"></v-head>
		<div class="contentBox">
			<!-- <van-cell title="会议缴费列表" is-link @click="go('meetPaymentList')" icon="balance-list-o"  /> -->
			<van-cell title="会费开票" is-link @click="go('invoiceList',1)" icon="label-o" />
			<van-cell title="会议费开票" is-link @click="go('invoiceList',2)" icon="bookmark-o" />
			<van-cell title="收件管理" is-link @click="go('mailManage')" icon="location-o" />
		</div>
		<vNavbar :active="navActive" @on_chang_active="changActive"></vNavbar>
	</div>
</template>

<script>
	import {
		unRead,
		getUser,
	} from "@/api/dictionary";
	import vHead from "../../components/header.vue";
	import vNavbar from "../../components/navbar.vue";
	import { Icon, Row, Col, Button, Swipe, SwipeItem, Cell } from 'vant';
	import { getSessionStore } from "../../utils/sessionStorage.js";
	import { mapGetters, mapState, mapActions } from "vuex";
	export default {
		data() {
			return {
				title: "发票管理",
				unReadNum: 0,
				iconNumber: true,
				userInfo: {},
				navActive: 4,
				gender: 1,
			};
		},
		components: {
			vHead,
			vNavbar,
			[Icon.name]: Icon,
			[Row.name]: Row,
			[Col.name]: Col,
			[Button.name]: Button,
			[SwipeItem.name]: SwipeItem,
			[Swipe.name]: Swipe,
			[Cell.name]: Cell,
		},

		methods: {
			...mapActions(["getGroupMemberType", "getPersonMemberType"]),
			go(pathName, value) {
				if (value) {
					this.$router.push({ name: pathName, query: { "type": value } });
				} else {
					this.$router.push({ name: pathName });
				}

			},
			changActive(val) {
				this.navActive = val;
			},
			formatTime: function (dateUnix) {
				if (!dateUnix) return null;
				let time = dateUnix.substring(0, 10);
				return time;
			},
			seeMemberInfo: function () {
				this.$router.push({ name: 'ceshi' });
			},
			unRead() {
				unRead({ "memberId": this.memberId }).then(res => {
					if (res.success) {
						this.unReadNum = res.result;
						if (this.unReadNum == 0) {
							this.iconNumber = false;
						}
					}
				})
			},
			getUserInfo() {
				getUser().then(res => {
					if (res.success) {
						this.userInfo = res.result;
						this.gender = res.result.gender;
					}
				})
			}
		},
		computed: {
			// ...mapState(["userInfo"]),
			...mapGetters(["getMemberType"])
		},
		mounted() {
			this.memberId = getSessionStore("memberId");
			this.getPersonMemberType();
			this.unRead();
			this.getUserInfo();
		}
	};
</script>
<style lang="less" scoped>
	.contentBox {
		margin-top: 55px;
		border-top: #f3f6fb solid 10px;
	}

	.contentBox /deep/.van-cell {
		padding: 15px 15px;
	}

	/deep/.van-nav-bar__title,
	/deep/.van-nav-bar__text {
		color: #000 !important;
	}

	/deep/.sign_out {
		color: #000;
	}

	.titde {
		overflow: hidden;
		font-size: 16px;
		color: #fff;
		margin-bottom: 25px;
		padding: 5px 0;
	}

	.titde h4 {
		float: left;
	}

	.titde span {
		float: right;
	}

	.means {
		background: url("../../assets/images/bg_c.jpg");
		background-size: cover;
		padding: 60px 13px 35px 13px;
		overflow: hidden;

		.van-button {
			float: right;
			background: #fff;
			color: #378be1;
			border: none;
			line-height: 26px;
			height: 30px;
			margin-top: 20px;
		}
	}

	.artBox {
		width: 58px;
		height: 58px;
		overflow: hidden;
		border: #fff solid 2px;
		border-radius: 100%;
		margin-top: 6px;
		float: left;
	}

	.portrait {
		width: 58px;
		height: 58px;
		display: block;
	}

	.means_name {
		float: left;
		font-size: 14px;
		color: #fff;
		margin-top: 3px;
		line-height: 24px;
		margin-left: 10px;
	}

	.means_name>p:first-of-type {
		font-size: 15px;
	}

	.means_name>p,
	.means_name>p span {
		font-size: 13px;
		color: #fff;
	}

	.means_name>p span {
		margin-right: 6px;
	}

	.more {
		float: right;
		margin-top: 30px;
		color: #fff;
	}

	.member_means {
		background: #fff;
		border-radius: 5px;
		padding: 23px 0;
		overflow: hidden;
		margin-top: -10px;
	}

	.member_means dl {
		width: 33%;
		float: left;
		text-align: center;
		font-weight: bold;
		color: #007bff;
		border-right: #efefef solid 1px;
	}

	.member_means dl dt {
		font-size: 18px;
	}

	.member_means dl dd {
		margin-top: 10px;
		font-size: 14px;
		font-weight: 100;
		color: #294073;
	}

	.icon_img {
		padding: 15px 10px;
		font-size: 14px;
		text-align: center;
		background: #fff;
		margin-top: 13px;
		border-radius: 5px;
		padding-bottom: 13px;
	}

	.icon_img>h4 {
		font-size: 16px;
		font-weight: 100;
		text-align: left;
		padding: 10px 15px;
		padding-bottom: 5px;
	}

	.icon_img img {
		width: 55%;
		display: inline-block;
		margin-bottom: 10px;
	}

	.van-col {
		padding: 15px 0;
	}

	.van-col h4 {
		position: relative;
	}

	.van-col i {
		text-align: center;
		color: #fff;
		font-weight: bold;
		background: red;
		font-size: 10px;
		display: block;
		position: absolute;
		right: 20%;
		width: 14px;
		height: 14px;
		border-radius: 50px;
		line-height: 14px;
		top: -68px;
	}

	.advcent {
		margin-top: 15px;
		padding: 16px 15px;
		background: #fff;
	}

	.my-swipe .van-swipe-item {
		color: #fff;
		font-size: 20px;
		height: 90px;
		text-align: center;
		background-color: #39a9ed;
		border-radius: 5px;
	}

	.my-swipe .van-swipe-item img {
		width: 100%;
		border-radius: 5px;
		display: block;
	}
</style>